export const Open = 'open';
export const Close = 'close';
export const Message = 'message';
export const Error = 'error';
